import { render, staticRenderFns } from "./CardInstitution.vue?vue&type=template&id=295b2860&scoped=true"
import script from "./CardInstitution.vue?vue&type=script&lang=js"
export * from "./CardInstitution.vue?vue&type=script&lang=js"
import style0 from "./CardInstitution.vue?vue&type=style&index=0&id=295b2860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b2860",
  null
  
)

export default component.exports